// Precision and valid range definitions
const PRECISION = 1e6;

/**
 * Finalizes a computed value by rounding it to the specified precision.
 * This should be used at the end of complete calculations or when making critical decisions.
 *
 * @param value - The raw computed value.
 * @returns The rounded value.
 */
export function finalize(value: number): number {
  return Math.round(value * PRECISION) / PRECISION;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

// Constants
export const HALF = finalize(0.5);
export const HALF_PI = finalize(Math.PI / 2);
